import Vue from 'vue';
// eslint-disable-next-line import/no-cycle
import store from '@/store';
import {
  smallSmartphonePortrait,
  smartphonePortrait,
  smartphoneLandscape,
  tabletLandscape,
  desktop,
} from '@/utils/media-query-list';
import {
  SET_SMALL_SMARTPHONE_PORTRAIT,
  SET_SMARTPHONE_PORTRAIT,
  SET_SMARTPHONE_LANDSCAPE,
  SET_TABLET_LANDSCAPE,
  SET_DESKTOP,
  SET_SCROLLBAR_WIDTH,
  ENABLE_OFFLINE_MODE,
} from './mutation-types';

smallSmartphonePortrait.addListener(() => {
  store.commit(`device/${SET_SMALL_SMARTPHONE_PORTRAIT}`, smallSmartphonePortrait.matches);
});
smartphonePortrait.addListener(() => {
  store.commit(`device/${SET_SMARTPHONE_PORTRAIT}`, smartphonePortrait.matches);
});
smartphoneLandscape.addListener(() => {
  store.commit(`device/${SET_SMARTPHONE_LANDSCAPE}`, smartphoneLandscape.matches);
});
tabletLandscape.addListener(() => {
  store.commit(`device/${SET_TABLET_LANDSCAPE}`, tabletLandscape.matches);
});
desktop.addListener(() => {
  store.commit(`device/${SET_DESKTOP}`, desktop.matches);
});

export default {
  [SET_SMALL_SMARTPHONE_PORTRAIT](state, isType) {
    state.isSmallSmartphonePortrait = isType;
  },

  [SET_SMARTPHONE_PORTRAIT](state, isType) {
    state.isSmartphonePortrait = isType;
  },

  [SET_SMARTPHONE_LANDSCAPE](state, isType) {
    state.isSmartphoneLandscape = isType;
  },

  [SET_TABLET_LANDSCAPE](state, isType) {
    state.isTabletLandscape = isType;
  },

  [SET_DESKTOP](state, isType) {
    state.isDesktop = isType;
  },

  [SET_SCROLLBAR_WIDTH](state) {
    if (!state.scrollbarWidth) {
      // Creating invisible container
      const outer = document.createElement('div');
      outer.style.visibility = 'hidden';
      outer.style.overflow = 'scroll';
      outer.style.msOverflowStyle = 'scrollbar';
      document.body.appendChild(outer);

      const inner = document.createElement('div');
      outer.appendChild(inner);
      Vue.set(state, 'scrollbarWidth', outer.offsetWidth - inner.offsetWidth);
      outer.parentNode.removeChild(outer);
    }
  },

  [ENABLE_OFFLINE_MODE](state, enable) {
    state.offlineMode = enable;
  },

};
